export default {
  title: 'Notificações de reservas',
  label: 'Para onde devemos enviar as notificações de reservas?',
  placeholder: 'p. ex. reservas@oseurestaurante.pt',
  helper:
    'Serve qualquer email — não precisa de acesso ao painel. Pode alterá-lo ou adicionar mais depois em Reservas → Definições → Notificações e confirmação.',
  errors: {
    required: 'Adicione um email para receber as notificações de reservas.',
    invalid: 'Introduza um email válido, como nome@restaurante.pt.',
  },
};
